import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Card, Row, Col, Form, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";

function AddParentGroup() {
  const navigate = useNavigate();
  const routeLocation = useLocation();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const userData = sessionStorage.getItem("user");
  const userObj = userData ? JSON.parse(userData) : {};

  const [editId, setEditId] = useState(null);

  const [form, setForm] = useState({
    parent_group_id: 0,
    parent_group_code: "",
    parent_group_name: "",
    school_id: userObj?.school_id || "",
  });

  // Load edit data if navigated with rowData
  useEffect(() => {
    if (routeLocation.state?.rowData) {
      const d = routeLocation.state.rowData;
      setEditId(d.parent_group_id);
      setForm({
        parent_group_id: d.parent_group_id || 0,
        parent_group_code: d.parent_group_code || "",
        parent_group_name: d.parent_group_name || "",
        school_id: userObj?.school_id || "",
      });
      window.history.replaceState({}, document.title);
    }
    // eslint-disable-next-line
  }, []);

  const handleChange = (e) => {
    const { id, value } = e.target;
    // Block digits in parent_group_name
    if (id === "parent_group_name" && /\d/.test(value)) return;
    setForm((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.parent_group_name.trim())
      return toast.error("Parent Group Name is required");
    if (!form.parent_group_code.trim())
      return toast.error("Parent Group Code is required");
    if (/\d/.test(form.parent_group_name))
      return toast.error("Parent Group Name must not contain digits");

    const payload = {
      parent_group_id: editId ? Number(form.parent_group_id) : 0,
      parent_group_code: form.parent_group_code.trim(),
      parent_group_name: form.parent_group_name.trim(),
      school_id: Number(userObj?.school_id),
      user: userObj?.user_name,
    };

    try {
      const res = await axios.post(
        `${baseUrl}/parent_group_create_update/`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      const first = Array.isArray(res.data) ? res.data[0] : res.data;

      if (first?.status === "SUCCESS") {
        toast.success(editId ? "Updated Successfully" : "Created Successfully");
        handleReset();
        navigate("/finance/parent-group");
      } else {
        toast.error(first?.message || "Failed");
      }
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.error || "Save failed");
    }
  };

  const handleReset = () => {
    setEditId(null);
    setForm({
      parent_group_id: 0,
      parent_group_code: "",
      parent_group_name: "",
      school_id: userObj?.school_id || "",
    });
  };

  return (
    <div className="pageBody">
      <ToastContainer />
      <Container fluid>
        <Card>
          <Card.Body>
            <form onSubmit={handleSubmit}>
              <Row>
                <Col xs={12}>
                  <h6 className="commonSectionTitle">
                    {editId ? "Edit Parent Group" : "Parent Group Details"}
                  </h6>
                </Col>
              </Row>

              <Row>
                {/* Parent Group Code */}

                {/* Parent Group Name */}
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <div className="commonInput">
                    <Form.Group controlId="parent_group_name">
                      <Form.Label>
                        Parent Group Name <span className="requiredStar">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        id="parent_group_name"
                        value={form.parent_group_name}
                        placeholder="Enter Parent Group Name"
                        maxLength={200}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </div>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <div className="commonInput">
                    <Form.Group controlId="parent_group_code">
                      <Form.Label>
                        Parent Group Code <span className="requiredStar">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        id="parent_group_code"
                        value={form.parent_group_code}
                        placeholder="Enter Parent Group Code"
                        maxLength={50}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </div>
                </Col>

              </Row>

              <div className="d-flex justify-content-between mt-3">
                <Button
                  type="button"
                  variant="primary"
                  className="btn-info clearBtn"
                  onClick={handleReset}
                >
                  Reset
                </Button>

                <div>
                  <Button
                    type="button"
                    variant="primary"
                    className="btn-danger secondaryBtn me-2"
                    onClick={() => window.history.back()}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="primary"
                    className="btn-success primaryBtn"
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </form>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default AddParentGroup;